<script setup lang="ts">
import { ref } from 'vue'
import charts from './components/charts.vue'

// 页面配置
definePage({
  name: 'market-hold',
  meta: {
    title: '经纪商持股列表',
  },
})
const router = useRouter()
function onSwitchPage(name: any) {
  router.push({ name })
}
const tabList = ref([
  {
    name: '近1日',
  },
  {
    name: '近1周',
  },
  {
    name: '近1月',
  },
  {
    name: '近1季',
  },
  {
    name: '近1年',
  },
])

const active = ref(0)

const list = ref([
  {
    name: '药明巨诺-B',
    code: '01919.HK',
    a: 0.03,
    b: 0.02,
  },
  {
    name: '药明巨诺-v',
    code: '01919.HK',
    a: 0.03,
    b: 0.02,
  },
  {
    name: '药明巨诺-c',
    code: '01919.HK',
    a: 0.1,
    b: 0.02,
  },
  {
    name: '药明巨诺-B',
    code: '01919.HK',
    a: 0.03,
    b: 0.09,
  },
  {
    name: '药明巨诺-B',
    code: '01919.HK',
    a: 0.03,
    b: 0.22,
  },
  {
    name: '药明巨诺-B',
    code: '01919.HK',
    a: 0.03,
    b: 0.07,
  },
  {
    name: '药明巨诺-B',
    code: '01919.HK',
    a: 0.06,
    b: 0.02,
  },
])

const showPopover = ref(false)
const actions = [
  { text: '持股比例' },
  { text: '持股股数' },
  { text: '持股市值' },
]
</script>

<template>
  <FmPageLayout navbar back :navbar-border="false">
    <div class="m-b-7px bg-[#fff] p-l-7px p-r-7px">
      <div class="h-34px flex items-center justify-center text-15px" @click="onSwitchPage('market-hold-list')">
        <div>长江证劵</div>
        <FmIcon name="tabler:chevron-down" class="text-17px" />
      </div>
      <div class="h-30px flex items-center gap-5px">
        <div class="text-15px">
          持股变化
        </div>
        <FmIcon name="ri:share-forward-box-line" class="text-lg color-[#999]" />
      </div>
      <div class="flex items-center justify-between">
        <div class="text-9px color-[#636367]">
          单位：亿港元
        </div>
        <div class="flex items-center justify-between text-13px color-[#3C78FF]" @click="onSwitchPage('InstitutionNumber')">
          <div>券商列表</div>
          <FmIcon name="line-md:chevron-right" class="text-lg" />
        </div>
      </div>
      <div class="h-200px">
        <charts />
      </div>
    </div>

    <div class="bg-[#fff] p-l-7px p-r-7px">
      <div class="h-30px flex items-center gap-5px">
        <div class="text-15px">
          持股分布
        </div>
      </div>
      <div class="flex justify-center gap-10px p-b-15px p-t-15px">
        <div v-for="(value, index) in tabList" :key="index" :class="[active === index && 'active']" class="h-22px w-56px text-center text-11px line-height-20px" style="border: 1px solid #e4e5e9;" @click="active = index">
          {{ value.name }}
        </div>
      </div>
      <div class="text-11px color-[#999]">
        更新:2025/12/25
      </div>
      <div class="h-40px flex items-center justify-between text-13px font-500">
        <div>2025/12/18</div>
        <div>参与家数：502家</div>
        <van-popover v-model:show="showPopover" :actions="actions">
          <template #reference>
            <div class="flex items-center justify-between">
              <div>持股比例</div>
              <FmIcon name="tabler:chevron-down" class="text-17px" />
            </div>
          </template>
        </van-popover>
      </div>
    </div>
    <vxe-table
      header-row-class-name="table-header"
      :data="list"
    >
      <vxe-column field="name" title="名称/代码" width="30%">
        <template #default="{ row }">
          <div class="van-ellipsis text-15px font-500">
            {{ row.name }}
          </div>
          <div class="text-13px">
            {{ row.code }}
          </div>
        </template>
      </vxe-column>
      <vxe-column field="a" title="持股比例" align="center" width="40%" sortable>
        <template #default="{ row }">
          <div>
            <div class="text-11px" style="text-align: left;">
              {{ row.a }}%
            </div>
            <div class="h-8px w-80px bg-[#ECECEC]">
              <div class="h-8px bg-[#3C78FF]" :style="{ width: `${row.a * 100}%` }" />
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column field="b" width="30%" title="持股比例" align="right" sortable>
        <template #default="{ row }">
          <div>
            <div class="text-11px" style="text-align: left;">
              {{ row.b }}%
            </div>
            <div class="h-8px w-80px bg-[#ECECEC]">
              <div class="h-8px bg-[#E51A2D]" :style="{ width: `${row.b * 100}%` }" />
            </div>
          </div>
        </template>
      </vxe-column>
    </vxe-table>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.active {
  color: #fff;
  background: #3c78ff;
  border-color: #3c78ff !important;
}
</style>
